import React from 'react'
import './Contact.css'

import ContactCard from './ContactCard'
const Contact = () => {
  return (
    <> 
    <div className="new_banner1"></div>
    <h1 className="contact_heading">Contact Us</h1>
    <div className="contact_page">

        <ContactCard
            heading ="About"
            data="0prep is a web app based on react which provides a valuable resource for students who are looking for last-minute exam preparation. 0prep focus on providing high-quality, reliable information."
            button="Read More"
            src="/FaqPage"
        />
        <ContactCard
            heading ="Founder"
            data="Utkarsh Gupta is the developer and designer of 0prep, which contains last minute prep notes with proper guidance in any particular area, "
            button="Contact Me"
            src="/Team"
        />

    </div>





 
    </>
  )
}



export default Contact